import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAlarmSystem } from '@obvious.tech/constellation'

export const AlarmSystem = defineEntity('AlarmSystem', {
  endpoint: 'alarms/api/AlarmSystem',
  schema: SNoop<IAlarmSystem>(),
})
